var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.93.6c.672 0 1.2.216 1.584.648.432.384.648.912.648 1.584v45.936c-.048.672-.288 1.224-.72 1.656-.432.384-.96.576-1.584.576a2.155 2.155 0 01-1.584-.648 2.155 2.155 0 01-.648-1.584V27.312H5.394v21.456a2.433 2.433 0 01-.72 1.584c-.432.432-.96.648-1.584.648-.672 0-1.224-.192-1.656-.576-.384-.432-.576-.984-.576-1.656V2.832c0-.672.216-1.2.648-1.584C1.938.816 2.49.6 3.162.6c.624 0 1.152.216 1.584.648.432.432.648.96.648 1.584v20.304h29.232V2.832c0-.624.216-1.152.648-1.584A2.403 2.403 0 0136.93.6z",
    fill: "currentColor"
  })));
}
export default SvgH;